import React       from 'react';
import ReactDom    from 'react-dom';
import Moment      from 'moment';

import Const       from 'fw_const';
import Utils       from 'utils';

import ProfilingEazyGender from '@common/influencer/parts/profiling/profiling-eazy-gender';
import ProfilingGeneGender from '@common/influencer/parts/profiling/profiling-gene-gender';
import ProfilingWordcloud  from '@common/influencer/parts/profiling/profiling-wordcloud';

import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';
// -------------------------------------------------------

class SummaryMainScore extends React.Component {
  render() {
    let data = this.props.data;
    
    let profiling = {'M.13-17': 0, 'M.18-24': 0, 'M.25-34': 0, 'M.35-44': 0, 'M.45-54': 0, 'M.55-64': 0, 'M.65+': 0, 'F.13-17': 0, 'F.18-24': 0, 'F.25-34': 0, 'F.35-44': 0, 'F.45-54': 0, 'F.55-64': 0, 'F.65+': 0 };
    
    let reports = data.report.list;
    reports = reports.map((d) => {
      d.like_count = 0;
      try { if( d.like_list != null ) d.like_count = d.like_list.split(',').length; } catch(e) {}
      return d;
    });
    
    // フォロワーの年代/性別比
    let report_count = 0;
    try {
      reports.map((d) => {
        if( d.like_count < 10 ) return;
        try {
          let json = JSON.parse(d.profiling);
          for( let i in json ) profiling[i] += json[i];
          
          report_count++;
        } catch(e) {}
      });
      
      for( let i in profiling ) profiling[i] = Math.round(profiling[i] / report_count);
    } catch(e) {}
    
    // フォロワーの性別比
    let man_per = 0;
    try { for( let i in profiling ) if( i.indexOf('M.') >= 0 ) man_per += profiling[i]; } catch(e) {}
    
    // ワードクラウド
    let wordcloud = {};
    try {
      let obj = {};
      reports.map((d) => {
        if( d.like_count < 10 ) return;
        try {
          let json = JSON.parse(d.wordcloud);
          for( let i in json ){
            if( obj[i] == undefined ) obj[i] = 0;
            obj[i] += json[i];
          }
        } catch(e) {}
      });
      
      let ary = [];
      for( let i in obj ) ary.push({ id: i, count: obj[i] });
      ary = Utils.sort(ary, 'count');
      ary.map((d, key) => { if( key < 100 ) wordcloud[d.id] = d.count; });
    } catch(e) {}
    
    if( report_count == 0 ){
      return (
        <div className="report-none">
          <div className="none">プロファイリングできる投稿がありません</div>
        </div>
      );
    } else {
      return (
        <div className="report-profiling influencer-profiling">
          <div className="gender-generation">
            <ProfilingEazyGender title="フォロワーの性別比" mode="graph" profiling={{ man_per: man_per, woman_per: (100 - man_per) }} />
            <ProfilingGeneGender title="フォロワーの年代/性別比" mode="graph" profiling={JSON.stringify(profiling)} />
          </div>
          <ProfilingWordcloud title="フォロワーのワードクラウド" wordcloud={JSON.stringify(wordcloud)} />
        </div>
      );
    }
  }
}
// -------------------------------------------------------

// レンダリング処理
export default SummaryMainScore;